import React from 'react';
import { Route, Switch } from 'react-router';
import Tabs from '../components/Tabs';
import roomServiceData from '../constants/pagesData/roomServiceData';
import styled from 'styled-components';
import minibar from '../assets/files/minbar.png';

const RoomService = ({ t }) => {
  return (
    <RoomServiceWrapper>
      <img src={minibar} style={{ width: '100%', height: 'auto' }} />
    </RoomServiceWrapper>
  );
};

const RoomServiceWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export default RoomService;
